import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog"
import { buttonVariants } from "./ui/button"
import { cn } from "../lib/utils"

/**
 * ConfirmDialog - A reusable confirmation dialog for destructive actions
 */
export function ConfirmDialog({
  trigger,
  title = "Are you sure?",
  description,
  confirmLabel = "Continue",
  cancelLabel = "Cancel",
  variant = "destructive",
  onConfirm,
  open,
  onOpenChange,
}) {
  const handleConfirm = () => {
    onConfirm?.()
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {trigger && <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className={cn(
              variant === "destructive" &&
                buttonVariants({ variant: "destructive" })
            )}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

/**
 * DeleteConfirmDialog - Pre-configured for delete operations
 */
export function DeleteConfirmDialog({
  trigger,
  title = "Delete this item?",
  description = "This action cannot be undone.",
  itemName,
  onConfirm,
  open,
  onOpenChange,
}) {
  return (
    <ConfirmDialog
      trigger={trigger}
      title={title}
      description={
        itemName
          ? `Are you sure you want to delete "${itemName}"? ${description}`
          : description
      }
      confirmLabel="Delete"
      variant="destructive"
      onConfirm={onConfirm}
      open={open}
      onOpenChange={onOpenChange}
    />
  )
}
